/*
 * @Author: suxueqin
 * @Date: 2021-01-06
 * @Last Modified by: yanghuizi
 * @Last Modified time: 2021-11-17 09:28:15
 */

/** 判断是否是 Plain Object */
function isObject(obj) {
  return obj && "object" === typeof obj && !isArray(obj);
}

function isArray(obj) {
  return obj instanceof Array;
}

function isFunction(obj) {
  return "function" === typeof obj;
}

function isString(str) {
  return "string" === typeof str;
}

/**
 * ==============================================
 */

/**
 * 转换 key-value 的 value 值
 * @param {object} obj Plain Object
 * @param {object} map Plain Object
 *
 * key-value 格式的 `map` 的 `value` 如果是函数，则接收 obj 的 `(value, key, obj)` 作为参数，
 * 并且它的返回值作为 `obj[key]` 的值；否则 `obj[key] = value`。
 */
function convert(obj, map) {
  let result = {};
  if (isObject(obj) && isObject(map)) {
    for (let k in obj) {
      if (map.hasOwnProperty(k)) {
        let val = map[k];
        result[k] = isFunction(val) ? val(obj[k], k, obj) : val;
      } else {
        result[k] = obj[k];
      }
    }
  }
  return result;
}

/** 限制点击频率 */
function debounce(fn, wait = 300, immediate) {
  let cache = {};

  return function() {
    cache.args = [...arguments];
    if (!cache.timer) {
      if (immediate) {
        fn.apply(this, cache.args);
      }
      cache.timer = setTimeout(() => {
        cache.timer = null;
        if (!immediate) {
          fn.apply(this, cache.args);
        }
      }, wait);
    }
  };
}

/** 过滤掉指定的键 */
function filter(obj, keys) {
  let result = {};
  if (isObject(obj) && isArray(keys)) {
    for (let k in obj) {
      if (!~keys.includes(k)) {
        result[k] = obj[k];
      }
    }
  }
  return result;
}

/** 拾取指定的键 */
function pick(obj, keys) {
  let result = {};
  if (isObject(obj) && isArray(keys)) {
    for (let k of keys) {
      if (obj.hasOwnProperty(k)) {
        result[k] = obj[k];
      }
    }
  }
  return result;
}

/** 返回 promise */
function promisify(fn, options, ctx) {
  if (!options) options = {};
  let { success, fail, complete } = options;
  return new Promise((resolve, reject) => {
    fn.call(
      ctx,
      Object.assign({}, options, {
        success: resolve,
        fail: reject,
        complete: null
      })
    );
  })
    .then(success, fail)
    .then(complete);
}

/** 将对象转换为 query string */
function qstringify(data, encode = true) {
  if (!isObject(data)) return "";
  let qs = [];
  for (let k in data) {
    qs.push(`${k}=${encode ? encodeURIComponent(data[k]) : data[k]}`);
  }
  return qs.join("&");
}

/**
 * 与 convert 函数类似，但是转换 obj 的键名而非值。
 *
 * `map` 参数的 `value` 如果是函数，则接收 `(key, obj)` 作为参数，返回值为新键名。
 * 如果 `options.ignore` 为假，则保留不参加转换的其他键值。
 * 默认 `options.ignore` 为真，相当于可变键名的 pick 函数。
 */
function translate(obj, map, options) {
  let { ignore = false } = options || {};
  let result = {};

  if (isObject(obj) && isObject(map)) {
    for (let k in obj) {
      if (map.hasOwnProperty(k)) {
        let val = map[k];
        if (isFunction(val)) {
          val = val(k, obj);
        }
        result[val] = obj[k];
      } else if (!ignore) {
        // 如果禁止忽略其他键名，则应保留其他键名的值
        result[k] = obj[k];
      }
    }
  }
  return result;
}

/**
 * 将秒转换为分秒格式：`mm:ss`
 * @param {number} seconds 秒数
 */
function formatMMSS(seconds) {
  let restSeconds = seconds % 60;
  let minutes = (seconds - restSeconds) / 60;
  return `${minutes < 10 ? "0" + minutes : minutes}:${
    restSeconds < 10 ? "0" + restSeconds : restSeconds
  }`;
}

let _base = 0;
function uniqueId() {
  return ++_base;
}

/**
 * 解析url
 * @param {string} url
 */
function parseUrl(url) {
  if (typeof url === "string") {
    let result = /(^https?:\/\/.*?\/)(.*)$/.exec(url);
    if (result) {
      return { host: result[1], path: result[2] };
    }
  }
}

const formatTime = date => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();

  return (
    [year, month, day].map(formatNumber).join("-") +
    " " +
    [hour, minute, second].map(formatNumber).join(":")
  );
};

const formatNumber = n => {
  n = n.toString();
  return n[1] ? n : "0" + n;
};

export {
  formatTime,
  convert,
  debounce,
  filter,
  formatMMSS,
  isArray,
  isFunction,
  isObject,
  isString,
  parseUrl,
  pick,
  promisify,
  qstringify,
  translate,
  uniqueId
};



// WEBPACK FOOTER //
// ./src/utils/func.js